<div class="container col-12">
    <div class="card">
      <h3 class="title-h4-blue">Datos del perfil</h3>
      <hr />
      <form [formGroup]="perfilForm">
        <!-- Email -->
        <div class="input-cont">
          <div class="input-container">
            <input
              class="input-reservas disabled"
              type="email"
              id="email"
              name="email"
              placeholder="Correo electrónico"
              formControlName="email"
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            />
            <label for="email" class="input-label input-label-disabled"
              >Correo electrónico</label
            >
            <img src="./assets/correo.svg" alt="" />
          </div>
        </div>
        <!-- Telefono casa -->
        <div class="input-cont">
          <div class="input-container">
            <input
              class="input-reservas disabled"
              type="phone"
              id="telefonoCasa"
              name="telefonoCasa"
              placeholder="Teléfono"
              formControlName="telefonoCasa"
            />
            <label for="telefonoCasa" class="input-label input-label-disabled"
              >Teléfono</label
            >
            <img src="./assets/phone.svg" alt="" />
          </div>
        </div>
        <!-- Telefono celular -->
        <div class="input-cont">
          <div class="input-container">
            <input
              class="input-reservas disabled"
              type="phone"
              id="telefonoCelular"
              name="telefonoCelular"
              placeholder="Celular"
              formControlName="telefonoCelular"
            />
            <label for="telefonoCelular" class="input-label input-label-disabled"
              >Celular</label
            >
            <img src="./assets/phone.svg" alt="" />
          </div>
        </div>
      </form>
    </div>



    <div class="card">
        <h3 class="title-h4-blue">Datos bancarios</h3>
        <hr />
        <div class="tabla-cuentas-container">
          <table class="tabla-cuentas">
            <thead>
              <tr>
                @for (column of bankAccountsTableColumns; track column.key) {
                    <th>{{ column.label }}</th>
                  }
              </tr>
            </thead>
            <tbody>
              @for (account of bankAccounts(); track account.accountNumber) {
                <tr>
                  <td>{{ account.bankName }}</td>
                  <td>{{ account.accountType }}</td>
                  <td>{{ account.accountNumber }}</td>
                  <td>{{ account.currencyName }}</td>
                </tr>
              } @empty {
                <tr>
                  <td colspan="4" class="sin-datos">
                    No hay cuentas bancarias registradas
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

</div>
  